import { useMemo } from "react"
import { ShareAttachmentFragment } from "~/__generated__/graphql"
import { AppText } from "~/ui/app-text"

export const MessageAttachmentPoll: React.FC<{
  poll: NonNullable<ShareAttachmentFragment["poll"]>
}> = ({ poll }) => {
  const totalVotes = useMemo(
    () => poll.pollOptions.reduce((sum, opt) => sum + opt.pollVotesCount, 0),
    [poll.pollOptions]
  )
  const maxVotes = useMemo(
    () => Math.max(...poll.pollOptions.map((opt) => opt.pollVotesCount)),
    [poll.pollOptions]
  )

  return (
    <div className="flex w-full flex-col gap-4 rounded-2xl bg-white bg-opacity-80 p-6">
      <AppText variant="h3" className="pb-1 text-center">
        {poll.title}
      </AppText>
      <div className="flex flex-col gap-4">
        {poll.pollOptions.map((option) => {
          const percent = totalVotes > 0 ? (option.pollVotesCount / totalVotes) * 100 : 0
          const isMostVoted = option.pollVotesCount === maxVotes && maxVotes > 0
          return (
            <div key={option.id} className="flex w-full items-center gap-4">
              <div className="relative h-[50px] flex-1 overflow-hidden rounded-full bg-neutral-100">
                <div
                  className={`absolute left-0 top-0 h-full rounded-bl-full rounded-tl-full ${
                    isMostVoted ? "bg-base-blue" : "bg-base-yellow"
                  }`}
                  style={{ width: `${percent}%`, minWidth: percent > 0 ? 32 : 0 }}
                />
                <div className="relative z-10 flex h-full items-center justify-between px-4">
                  <AppText variant="h3" className="max-w-[80%] truncate uppercase">
                    {option.content}
                  </AppText>
                  <AppText variant="h3">{Math.round(percent)}%</AppText>
                </div>
              </div>
            </div>
          )
        })}
      </div>
      <AppText variant="caption" className="text-center text-neutral-500">
        {totalVotes} vote{totalVotes === 1 ? "" : "s"}
      </AppText>
    </div>
  )
}
